export default __webpack_public_path__ + "0aea2722a335803cb7800bce1978cd08.svg";